module.exports = __webpack_public_path__ + "img/cover-more.0f6b47c1.jpg";